<template>
  <ElForm
    :model="formModel"
    class="keyword-planner-result-search-form"
    @submit="submitForm"
  >
    <ElFormItem
      class="
        keyword-planner-result-search-form__form-item
        keyword-planner-result-search-form__form-item--tag-input
      "
      prop="keywords"
    >
      <TagInput
        v-model="formModel.internalKeywords"
        :max="MAX_ITEMS"
        class="keyword-planner-result-search-form__tag-input"
        :placeholder="$t('ADVERTISEMENT.KEYWORDPLANNER.SEARCH_PLACEHOLDER')"
      />
    </ElFormItem>
    <ElFormItem class="keyword-planner-result-search-form__form-item">
      <ElButton
        class="keyword-planner-result-search-form__submit-btn"
        :disabled="!formModel.internalKeywords.length"
        type="text"
        :icon="submitButtonIcon"
        @click="submitForm"
      />
    </ElFormItem>
  </ElForm>
</template>
<script>
import TagInput from '@@/common/TagInput';
import statsFilter from '@/mixins/statsFilter';
import { DIRECTION } from '@/store/types';
import { mapGetters } from 'vuex';
import { MAX_ITEMS } from '../common/constants';

export default {
  name: 'KeywordPlannerResultSearchForm',
  components: {
    TagInput,
  },
  mixins: [statsFilter],
  props: {
    keywords: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        internalKeywords: this.keywords,
      },
    };
  },
  computed: {
    ...mapGetters([DIRECTION]),
    MAX_ITEMS() {
      return MAX_ITEMS;
    },
    ranges() {
      return this.getStatsRangeFilters();
    },
    submitButtonIcon() {
      return this[DIRECTION] === 'rtl' ? 'el-icon-back' : 'el-icon-right';
    },
  },
  watch: {
    keywords() {
      this.formModel.internalKeywords = this.keywords;
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.formModel.internalKeywords);
    },
  },
};
</script>
<style lang="scss">
.keyword-planner-result-search-form {
  display: flex;
  justify-items: center;

  &__form-item {
    margin-right: $global-margin;
    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
    }
    margin-bottom: 0;

    &--tag-input {
      max-width: rem-calc(400px);
      width: 100%;
    }
  }

  &__tag-input {
    width: 100%;
  }

  &__range-input {
    max-width: rem-calc(125px);
    width: 100%;
  }

  &__submit-btn {
    font-size: rem-calc(18px);
  }
}
</style>
